module.exports = __webpack_public_path__ + "static/WEDDING E&M-375-f104aeb1dc01d93eb40eff6582af27bd.jpg";